import vue from 'vue';
const validObj = {
    maxlength: function (val, max) {
        if (val.length > max) return false;
        else return true;
    },
    minlength: function (val, min) {
        if (val.length < min) return false;
        else return true;
    },
    max: function (val, max) {
        if (isNaN(parseFloat(max))) {
            console.error('验证规则：max规则参数只能是数字类型');
            return false;
        }
        if (isNaN(parseFloat(val))) return false;
        if (parseFloat(val) > parseFloat(max)) return false;
        else return true;
    },
    min: function (val, min) {
        if (isNaN(parseFloat(min))) {
            console.error('验证规则：min规则参数只能是数字类型');
            return false;
        }
        if (isNaN(parseFloat(val))) return false;
        if (parseFloat(val) < parseFloat(min)) return false;
        else return true;
    },
    email: function (val) {
        return (/^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/).test(val);
    },
    idcard: function (code) {
        var city = {
            11: '北京',
            12: '天津',
            13: '河北',
            14: '山西',
            15: '内蒙古',
            21: '辽宁',
            22: '吉林',
            23: '黑龙江 ',
            31: '上海',
            32: '江苏',
            33: '浙江',
            34: '安徽',
            35: '福建',
            36: '江西',
            37: '山东',
            41: '河南',
            42: '湖北 ',
            43: '湖南',
            44: '广东',
            45: '广西',
            46: '海南',
            50: '重庆',
            51: '四川',
            52: '贵州',
            53: '云南',
            54: '西藏 ',
            61: '陕西',
            62: '甘肃',
            63: '青海',
            64: '宁夏',
            65: '新疆',
            71: '台湾',
            81: '香港',
            82: '澳门',
            91: '国外 '
        };
        if (!code || !(/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i).test(code)) return false;
        if (!city[code.substr(0, 2)]) return false;
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
                return false;
            }
        } else if (code.length == 15)
            return true;
        else return false;
        return true;
        //if (val.trim().length <= 0)
        //    return false;
        //return /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(val)
    },
    mobile: function (val) {
        return (/^(13[0-9]|15[0-9]|18[0-9]|17[7|0]|14[5])\d{8}$/).test(val);
    },
    phone: function (val) {
        return (/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/).test(val);
    },
    int: function (val) {
        return (/^-?[0-9]\d*$/).test(val);
    },
    positiveInteger: function (val) {
        return (/^[0-9]*[1-9][0-9]*$/).test(val);
    },
    float: function (val) {
        return (/^[+|-]?\d*\.?\d*$/).test(val);
    },
    positiveFloat: function (val) {
        return (/^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/).test(val);
    },
    all: function (val) {
        return true;
    }

};
const controlValid = {
    data: function () {
        return {
            Valid_Status__: true,
            Valid_ErrorMsg__: '',
            Valid_ShowMsg__: true,
            Valid_Group__: ''
        };
    },
    props: {
        validator: {
            type: Object
            //default: function () {
            //    return {
            //        required: false,
            //        rules: ["RuleName:Param"],
            //        rulesOne: ["RuleName","RuleName"],
            //        ruleCompare:[{value:"",rules:[{compare:"",rule:""}]}]
            //    }
            //}
        }
    },
    mounted: function () {
        this.initValid();
        this.doValid();
    },
    methods: {
        setValid: function (valid, mess) {
            this.Valid_Status__ = valid;
            if (mess !== undefined && mess !== '')
                this.validator.errorMess = mess;
            if (valid === true) {
                $(this.$el).find('.form-control-feedback').tooltip('destroy');
                this.Valid_ErrorMsg__ = '';
            } else {
                let mess1 = '<div style="white-space:nowrap;text-align:left;">{0}</div>';
                if (this.validator.hasOwnProperty('errorMess')){
                    mess1 = mess1.replace('{0}', this.validator.errorMess);
                    this.Valid_ErrorMsg__ = this.validator.errorMess;
                }
                else{
                    mess1 = mess1.replace('{0}', this.label + '输入有误！');
                    this.Valid_ErrorMsg__ = this.label + '输入有误！';
                }
                // this.Valid_ErrorMsg__ = mess1;
                $(this.$el).find('.form-control-feedback').tooltip({
                    title: mess1,
                    html: true
                });
            }
        },
        todoReg: function (ruleName, _value) {
            var param = null;
            if (ruleName.indexOf(':') >= 0) {
                var arr = ruleName.split(':');
                ruleName = arr[0];
                param = arr[1];
            }
            if (validObj[ruleName]) {
                if (param === null)
                    return validObj[ruleName](_value);
                else
                    return validObj[ruleName](_value, param);
            }
            console.error('验证错误：' + this.label + '验证规则方法"' + ruleName + '"不存在！');
            return true;
        },
        initValid: function () {
            if (!this.validator) return;
            if (this.validator.hasOwnProperty('group'))
                this.Valid_Group__ = this.validator.group;
            if (this.validator.hasOwnProperty('showMsg'))
                this.Valid_ShowMsg__ = this.validator.showMsg;
            //初始化验证效果
            if (this.validator.hasOwnProperty('rules')) {
                for (var i = 0; i < this.validator.rules.length; i++) {
                    var ruleName = this.validator.rules[i];
                    var param = null;
                    if (ruleName.indexOf(':') >= 0) {
                        var arr = ruleName.split(':');
                        ruleName = arr[0];
                        param = arr[1];
                    }
                    if (ruleName === 'maxlength') {
                        if (this.controlType === 'textbox') {
                            $(this.$el).find('input').attr('maxlength', param);
                        }
                    }
                }
            }
        },
        doValid: function () {
            if (!this.validator) return;
            var _value = this.value;
            var self = this;
            vue.nextTick(function () {
                if (self.controlType === 'select')
                    _value = $(self.$el).find('select').val();
                //#region 判断必填属性
                if (self.validator.hasOwnProperty('required')) {
                    if (self.validator.required) { //验证必填规则
                        if (_value === null || _value === undefined || _value.toString() === '' || _value.toString().length <= 0) {
                            self.setValid(false);
                            return;
                        }
                    } else { //非必填，如果为空，则不执行验证规则，默认通过
                        if (_value === null || _value === undefined || _value.toString() === '' || _value.toString().length <= 0) {
                            self.setValid(true);
                            return;
                        }
                    }
                } else {
                    console.error('验证错误：' + self.label + '缺少必要属性required');
                    self.setValid(false);
                    return;
                }
                //#endregion
                //#region 判断必须验证规则
                if (self.validator.hasOwnProperty('rules')) {
                    let ruleValid = true;
                    for (let i = 0; i < self.validator.rules.length; i++) {
                        let ruleName = self.validator.rules[i];
                        ruleValid = self.todoReg(ruleName, _value);
                        if (ruleValid === false) break;
                    }
                    if (ruleValid === false) {
                        self.setValid(false);
                        return;
                    }
                }
                //#endregion
                //#region 判断任一验证规则通过
                if (self.validator.hasOwnProperty('rulesOne')) {
                    let ruleValid = false;
                    for (let i = 0; i < self.validator.rulesOne.length; i++) {
                        let ruleName = self.validator.rulesOne[i];
                        ruleValid = self.todoReg(ruleName, _value);
                        if (ruleValid === true) break;
                    }
                    if (ruleValid === false) {
                        self.setValid(false);
                        return;
                    }
                }
                //#endregion
                //#region 判断比较规则
                if (self.validator.hasOwnProperty('ruleCompare')) {
                    for (let i = 0; i < self.validator.ruleCompare.length; i++) {
                        let compareValid = self.validator.ruleCompare[i];
                        if (compareValid.hasOwnProperty('rules')) {
                            var rulesValid = true;
                            for (var j = 0; j < compareValid.rules.length; j++) {
                                if (compareValid.rules[j].compare == compareValid.value) {
                                    rulesValid = self.todoReg(compareValid.rules[j].rule, _value);
                                    if (rulesValid == false) break;
                                }
                            }
                            if (rulesValid == false) {
                                self.setValid(false);
                                //break;
                                return;
                            }
                        }
                    }
                }
                //#endregion
                self.setValid(true);
            });
        }
    },
    watch: {
        'value': function (val) {
            if (this.controlType != 'select')
                this.doValid();
        },
        'validator': {
            deep: true,
            handler: function (val) {
                this.doValid();
            }
        }
    }
};

export default controlValid;



// WEBPACK FOOTER //
// ./src/mixins/control-valid.js